import React from 'react';
import DOMPurify from 'dompurify';

export default function ContentView({ content }) {
    const sanitizedContent = DOMPurify.sanitize(content, {
        ALLOWED_TAGS: ['ol', 'ul', 'li', 'p', 'strong', 'em', 'a', 'b', 'i', 'u'],
    });

    return (
        <div>
            <style>
                {`
                    .content-view ol {
                        list-style-type: decimal !important;
                        padding-left: 20px;
                    }
                    .content-view ul {
                        list-style-type: disc !important;
                        padding-left: 20px;
                    }
                    .content-view li {
                        margin-bottom: 5px;
                    }
		    .ql-editor p {
			margin-bottom: 10px;
		    }
                `}
            </style>
            <div className="ql-editor content-view" dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
        </div>
    );
}
